import { MusicDetail, MusicImage } from "./styled.components";
import { MusicSliderDataTypes } from "./types";

interface NormalSliderProps {
  data: MusicSliderDataTypes[];
}

export default function NormalSlider({ data }: NormalSliderProps) {
  const items = data.map((item, idx) => {
    return (
      <div
        key={idx}
        className="text-white my-auto text-center overflow-visible flex flex-col gap-[1vw] md:gap-[2vh] h-full w-full md:w-[50%]"
      >
        <a href={item.link}>
          <img
            src={item.img}
            alt="ffm image"
            className="transition-all w-full object-cover"
          />
        </a>
        <div className="mt-5 md:mt-0">
          <h2 className="font-bold italic">{item.title}</h2>
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary mt-[--space-btw-items] inline-block "
          >
            LISTEN NOW
          </a>
        </div>
      </div>
    );
  });

  return (
    <div className="grid grid-cols-1 md:flex flex-wrap gap-[5vw] md:gap-[4vh] justify-center">
      {items}
    </div>
  );
}
